import { useEffect, useState } from "react";
import * as Api from './Api';
import "./StoryText.css";
import { Button } from "@mui/material";
import { useLocalization } from "./LocalizationProvider";

interface StoryTextProps {
    paragraphs: string[];
}

function StoryText({ paragraphs }: StoryTextProps) {
    const [audioSource, setAudioSource] = useState<AudioBufferSourceNode | null>(null);

    const audioContext = new AudioContext();
    const local = useLocalization();
    const buttonText: string = local("msg-listen-story") as string;
    const [playing, setPlaying] = useState(false);

    useEffect(() => {
        if (!paragraphs || paragraphs.length <= 0)
            return;

        if (!audioSource) {
            Api.createAudio(paragraphs.join("")).then((data) => {
                if (!data)
                    throw Error("Couldn't generate audio.");

                audioContext.decodeAudioData(data, (buffer) => {
                    // Create a buffer source node
                    const source = audioContext.createBufferSource();

                    // Set the buffer of the source node to the decoded audio data
                    source.buffer = buffer;

                    // Connect the source to the audio context destination (speakers)
                    source.connect(audioContext.destination);

                    setAudioSource(source);
                }, (err) => {
                    // Handle decoding error
                    console.error('Error decoding audio data:', err);
                });
            });
        }

        return () => {
            if (audioSource) {
                if (playing) {
                    audioSource.stop();
                }

                audioSource.disconnect();
            }
        }
    }, [audioSource]);

    const onClick = () => {
        if (audioSource) {
            audioSource.start();
            setPlaying(true);
        }
    }

    return (
        <div className="storyContainer">
            {paragraphs.map((pgraph, idx) => 
                <p key={idx} className="storyText">{pgraph}</p>
            )}
            {audioSource && 
                <Button
                    sx={{
                        fontFamily: "Rubik Bubbles",
                        fontSize: "1em",
                        borderRadius: "1em",
                        padding: ".25em .8em",
                        backgroundColor: "blue",
                        color: "white",
                        width: "fit-content"
                    }}
                    variant="contained"
                    onClick={onClick}
                >
                    {buttonText}
                </Button>
            }
        </div>
    );
}

export default StoryText;